import { useState, useEffect, useMemo } from "react";
import { _get_user_transaction_history } from "../common/axios_services";
import moment from "moment";
import NumberFormat from "react-number-format";
import { Tag } from "antd";

export const useTransactionManagement = (type = "store") => {
  // 'restaurant', 'store', 'raw_food'
  const [fetchingLoyalty, setFetchingLoyalty] = useState(true);
  const [total_loyalty, setTotal_loyalty] = useState(0);
  const [per_page, setPer_page] = useState(10);
  const [loyalty_his, setLoyalty_his] = useState([]);
  const [pageLoy, setPageLoy] = useState(1);
  const [pageSizeLoy, setPageSizeLoy] = useState(10);
  const [transactionStatusFilter, setTransactionStatusFilter] = useState("all");

  const fetchUserWalletPayments = async () => {
    try {
      const isRestaurantHistory = type === "restaurant";
      const response = await _get_user_transaction_history({
        page: pageLoy,
        page_size: pageSizeLoy,
        account_type: "wallet",
        is_resturant_history: isRestaurantHistory,
      });
      setLoyalty_his(response.data.data?.orders);
      setFetchingLoyalty(false);
      setTotal_loyalty(response?.data?.pagination?.total);
    } catch (err) {
      console.log(err);
    }
  };

  const walletHistoryColumn = [
    {
      title: "",
      dataIndex: "sn",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Reference",
      dataIndex: "reference",
    },
    {
      title: "Service",
      dataIndex: "service",
    },
    {
      title: "Status",
      className: "column-number",
      dataIndex: "status",
      align: "center",
    },
    {
      title: "Credit",
      className: "column-number",
      dataIndex: "credit",
      align: "right",
    },
    {
      title: "Debit",
      className: "column-number",
      dataIndex: "debit",
      align: "right",
    },
  ];

  const filteredLoyaltyHis = useMemo(() => {
    if (transactionStatusFilter === "all") return loyalty_his;
    return loyalty_his.filter(
      (trans) => trans.payment_type === transactionStatusFilter
    );
  }, [loyalty_his, transactionStatusFilter]);

  const wallet_history_data = useMemo(() => {
    return filteredLoyaltyHis.map((trans, index) => ({
      key: index,
      sn: index + 1,
      date: moment(trans?.timestamp).format("HH:mm YYYY-MM-DD"),
      reference: (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            // Handle view transaction - can be passed as callback
          }}
        >
          {trans.referense_no}
        </span>
      ),
      service: trans.service,
      credit: (
        <div>
          {trans.payment_type === "credit" ? (
            <>
              <span className="currency">NGN</span>
              <NumberFormat
                thousandSeparator={true}
                displayType={"text"}
                value={Math.trunc(+trans.total_amount).toFixed(2)}
              />{" "}
            </>
          ) : (
            "-"
          )}
        </div>
      ),
      debit: (
        <div>
          {trans.payment_type === "debit" ? (
            <>
              <span className="currency">NGN</span>
              <NumberFormat
                thousandSeparator={true}
                displayType={"text"}
                value={Math.trunc(+trans.total_amount).toFixed(2)}
              />{" "}
            </>
          ) : (
            "-"
          )}
        </div>
      ),
      balance:
        type === "restaurant" ? (
          <div>
            {" "}
            <span className="currency">NGN</span>
            <NumberFormat
              thousandSeparator={true}
              displayType={"text"}
              value={Math.trunc(+trans.new_wallet_balance).toFixed(2)}
            />
          </div>
        ) : null,
      status: (
        <div style={{ textTransform: "capitalize" }}>
          {type === "restaurant" ? (
            trans.payment_type === "credit" ? (
              <Tag color="green">{trans.payment_type}</Tag>
            ) : (
              <Tag color="red">{trans.payment_type}</Tag>
            )
          ) : trans.payment_type === "credit" ? (
            <span style={{ color: "green" }}>{trans.payment_type}</span>
          ) : (
            <span style={{ color: "red" }}>{trans.payment_type}</span>
          )}
        </div>
      ),
    }));
  }, [filteredLoyaltyHis, type]);

  const change_loyalty = (selected_page, pageSize) => {
    setPageLoy(selected_page);
    setPageSizeLoy(pageSize);
    setFetchingLoyalty(true);
  };

  useEffect(() => {
    fetchUserWalletPayments();
  }, [pageLoy, pageSizeLoy]);

  return {
    fetchingLoyalty,
    total_loyalty,
    per_page,
    loyalty_his: filteredLoyaltyHis,
    pageLoy,
    pageSizeLoy,
    walletHistoryColumn,
    wallet_history_data,
    change_loyalty,
    fetchUserWalletPayments,
    transactionStatusFilter,
    setTransactionStatusFilter,
  };
};
